import React from 'react';
import { useParams } from 'react-router-dom';

import NetworkContainer from '@totem/components/portfolio/buildings/details/network/networkContainer';
import NetworkGraph from '@totem/components/portfolio/buildings/details/network/networkGraph';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

import './network.css';

const NetworkPage = () => {
  const { id } = useParams();

  return (
    <ContentLayout pageTitle={'Network'} contentStyle={{ padding: 0 }}>
      <NetworkContainer buildingId={id}>
        <div styleName="content">
          <div styleName="content-container">
            <div styleName="main-pane">
              <NetworkGraph />
            </div>
          </div>
        </div>
      </NetworkContainer>
    </ContentLayout>
  );
};

export default NetworkPage;
